export default __webpack_public_path__ + "static/media/brazil-flag.239f03bb.svg";